import { AppFrame } from "@onlinetools/ui";
import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <AppFrame title="Page not found.">
      <title>404 - Any Tool Online</title>
      <meta content="The page you're looking for doesn't exist." name="description" />
      <div className="panel" style={{ maxWidth: 520 }}>
        <p style={{ margin: "0 0 20px" }}>
          That page doesn't exist. Try one of the tools below, or head back home.
        </p>
        <div className="button-row">
          <Link className="primary-button" to="/">Back to home</Link>
          <Link className="secondary-button" to="/qr">QR Code Generator</Link>
        </div>
      </div>
    </AppFrame>
  );
}
